import { log } from 'log';
import { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import * as helpers from './helpers';
import { pushDispatcher } from '../../../usePushSubscription';
import { STACK, BATCH_REQUEST_ID } from '../../../../constants';
import { clearStackEntryTimeouts, removeStackEntry } from '../../../../helpers';

export const useOnMessage = () => {
    return useCallback(
        (rawMessage: object | string) => {
            const response = helpers.parseMessage(rawMessage);
            const correlationId = response.correlationId ?? response.data?.correlationId;
            const stackEntries = correlationId
                ? STACK.filter(({ request }) => request.correlationId === correlationId)
                : [];

            const stackEntry = correlationId
                ? stackEntries.find(({ request }) => request.responses.includes(response.ID)) || stackEntries[0]
                : STACK.find(({ request }) => request.responses.includes(response.ID));

            if (!stackEntry) {
                log('oapiPush', response);

                dispatcher.dispatch('server:message', response);
                pushDispatcher.trigger(response.ID, response);

                return;
            }

            const time = Date.now() - stackEntry.timestamp;

            // handle error response
            if (response.data?.error || response.data?.errorCode) {
                publicEventsAPIService.trigger('socket-error', {
                    requestId: stackEntry.request.ID,
                    responseId: response.ID,
                    error: response.data?.error,
                    errorCode: response.data?.errorCode,
                    time
                });

                stackEntry.reject({
                    reason: 'Request error',
                    request: stackEntry.request,
                    response,
                    time
                });

                if (stackEntry.request.ID === BATCH_REQUEST_ID) {
                    stackEntries.forEach(entry => {
                        clearStackEntryTimeouts(entry);
                        removeStackEntry(entry);
                    });
                }
            } else {
                publicEventsAPIService.trigger('socket-response', {
                    requestId: stackEntry.request.ID,
                    responseId: response.ID,
                    time
                });

                log('oapiResponse', {
                    ...response,
                    description: stackEntry.request.description,
                    time
                });

                stackEntry.resolve(response);
            }

            clearStackEntryTimeouts(stackEntry);
            removeStackEntry(stackEntry);

            dispatcher.dispatch('server:message', response);
            pushDispatcher.trigger(response.ID, response);
        },
        []
    );
};
